<script>
import { RouterLink } from 'vue-router';

export default {
  components: {  RouterLink }
};
</script>

<template>
  <div class="space"></div>
  <div class="fondo">
    <div class="container recuadro bg-dark mt-5 mb-5 p-5">
      <div class="pestanas">
        <RouterLink to="contratos"><button class="tablinks" :class="{ active: $route.path === '/info/contratos' }">Contratos</button></RouterLink>
        <RouterLink to="contadores"><button class="tablinks" :class="{ active: $route.path === '/info/contadores' }">Contadores</button></RouterLink>
        <RouterLink to="revendedores"><button class="tablinks" :class="{ active: $route.path === '/info/revendedores' }">Revendedores</button></RouterLink>
        <RouterLink to="recomendados"><button class="tablinks" :class="{ active: $route.path === '/info/recomendados' }">Recomendados</button></RouterLink>
        <RouterLink to="clientes-recomendados"><button class="tablinks" :class="{ active: $route.path === '/info/clientes-recomendados' }">Recomendados Clientes</button></RouterLink>
      </div>
      <RouterView/>
    </div>
  </div>
</template>
